<template>
  <main-container class="account-container" title="お知らせ" :showFooter="false">
    <div slot="main-content">
      <template v-if="isNewInfo">
        <div class="information-title-container">
          <h2>
            <div class="link" @click="changeLocation('model-list')">モデル作成・更新完了のお知らせ</div>
          </h2>
        </div>
        <div class="information-body-container"><p>モデルが作成、または更新されました。<br>リンクを押すとモデル一覧に移動します。</p></div>
      </template>
      <template v-for="information in informations">
        <div :id="'information-' + information.informationId" class="information-title-container"><h2>
          {{information.title}}({{information.releaseAt | date_format('YYYYMMDDHHmmss', 'YYYY/MM/DD')}})</h2></div>
        <div class="information-body-container"><p v-html="$options.filters.html_format(information.description)"></p>
        </div>
      </template>
    </div>
  </main-container>
</template>

<script lang="js">
import BaseView from '../base'
import WebApiClient from '../../api/web'
import { Code } from '../../api/base'

export default {
  name: 'InformationView',
  mixins: [BaseView],
  components: {},
  props: {},
  data () {
    return {
      informations: [],
      isNewInfo: false
    }
  },
  mounted () {
    WebApiClient.getInformations(this).then((response) => {
      if (response.data.code === Code.SUCCESS) {
        this.informations = response.data.result.informations
        this.$forceUpdate()
        this.$nextTick(() => {
          this.scrollToAnchor()
        })
      }
    })
  },
  methods: {
    onRefreshNotification (notifications, onlyIsNewInfo) {
      this.isNewInfo = notifications.isNewInfo
    }
  }
}

</script>

<style scoped>
  .information-title-container {
    padding: 25px 40px;
    background: #fff;
  }

  .information-title-container > h2 {
    font-size: 1.5rem;
    font-weight: normal;
    padding: 0;
  }

  .information-body-container {
    padding: 25px 40px;
    background: #f1f5f8;
    border-bottom: 1px solid #c0d5ef;
  }
</style>



// WEBPACK FOOTER //
// src/views/information/information.vue